// ============================================================================
// Relevance curves & recommended cosine-distance thresholds
// ----------------------------------------------------------------------------
// Source: Recommended_Thresholds_and_relevance_formulas.xlsx
// Calibrated for the gemini-model-2 embeddings (replaces the gemini-model-1
// numbers: the sigmoid denominators/exponents and every tier threshold moved,
// and Audience/Package switched from the cubic curve to the sigmoid).
//
// Relevance (%) = 100 / (1 + (cosineDistance / denominator) ** exponent)
//
// Note the curve denominator equals the "Maximum Reach" threshold for each
// API, so that tier always evaluates to exactly 50% relevance.
// ============================================================================

export const RELEVANCE_CURVES = {
	SEGMENTS: { denominator: 0.359, exponent: 7 },
	DOMAINS: { denominator: 0.44, exponent: 7 },
	APPS: { denominator: 0.43, exponent: 7 },
	AUDIENCE: { denominator: 0.39, exponent: 7 },
	PACKAGES: { denominator: 0.39, exponent: 7 },
};

// Recommended cosine-distance thresholds per API, by tier.
// "-" entries in the sheet (Categories / Keywords publish only a default tier)
// are simply absent here.
export const RECOMMENDED_THRESHOLDS = {
	SEGMENTS: {
		bestMatch: 0.29,
		strongMatch: 0.317,
		acceptable: 0.325,
		extended: 0.333,
		maximumReach: 0.359,
	},
	DOMAINS: {
		bestMatch: 0.37,
		strongMatch: 0.39,
		acceptable: 0.4,
		extended: 0.42,
		maximumReach: 0.44,
	},
	APPS: {
		bestMatch: 0.36,
		strongMatch: 0.38,
		acceptable: 0.39,
		extended: 0.41,
		maximumReach: 0.43,
	},
	AUDIENCE: {
		bestMatch: 0.32,
		strongMatch: 0.34,
		acceptable: 0.35,
		extended: 0.38,
		maximumReach: 0.39,
	},
	PACKAGES: {
		bestMatch: 0.33,
		strongMatch: 0.35,
		acceptable: 0.36,
		extended: 0.38,
		maximumReach: 0.39,
	},
	CATEGORIES: {
		strongMatch: 0.34,
	},
	KEYWORDS: {
		strongMatch: 0.24,
	},
};

// The sheet marks "Strong Match" as the default tier for every API.
export const DEFAULT_THRESHOLD_TIER = "strongMatch";

// Default cosine distance thresholds used when building domain search payloads.
// Include = the default (Strong Match) tier; exclude stays one tier looser so
// exclusions keep the slightly wider net they had before.
export const DEFAULT_DOMAIN_INCLUDE_QUERY_THRESHOLD =
	RECOMMENDED_THRESHOLDS.DOMAINS.strongMatch;
export const DEFAULT_DOMAIN_EXCLUDE_QUERY_THRESHOLD =
	RECOMMENDED_THRESHOLDS.DOMAINS.acceptable;

// Default category-search query threshold (sheet: Categories → Strong Match).
export const DEFAULT_CATEGORY_QUERY_THRESHOLD =
	RECOMMENDED_THRESHOLDS.CATEGORIES.strongMatch;

// Default keyword-search threshold (sheet: Keywords → Strong Match).
export const DEFAULT_KEYWORD_QUERY_THRESHOLD =
	RECOMMENDED_THRESHOLDS.KEYWORDS.strongMatch;

// Back-compat aliases: these named the single global curve before every API got
// its own. They now point at the Domains curve, which is where they were used.
export const RELEVANCE_SCORE_MIDPOINT = RELEVANCE_CURVES.DOMAINS.denominator;
export const RELEVANCE_CURVE_EXPONENT = RELEVANCE_CURVES.DOMAINS.exponent;

// Default relevance score (%) applied to LLM-generated search terms.
export const DEFAULT_QUERY_SCORE = 65;
